<template>
  <View direction="column" gap="lg">
    <Text variant="body-medium" color="secondary">
      Choose how strictly Tallo screens renters against the requirements.
    </Text>
    <ScreeningSensitivityCards v-model="form.fields.screeningSensitivity" />
    <Hint>This guides Tallo's conversations with renters and is never shown to them</Hint>
  </View>
</template>

<script setup lang="ts">
import { watch } from 'vue';

import { Hint, Text, View, useForm } from '@tallo/design-system';
import { useInvestorStore } from '@tallo/investor/investor';
import { ScreeningSensitivity, ScreeningSensitivityCards } from '@tallo/property';

import { useDetailsHolder } from '../../composables/details-holder';

/** The screening sensitivity alone, saved onto the holder's renter requirements; the rest of the row is left as it is */
const holder = useDetailsHolder();
const investorStore = useInvestorStore();

const form = useForm<{ screeningSensitivity: ScreeningSensitivity }>({
  screeningSensitivity: ScreeningSensitivity.MODERATE,
});

function populateForm() {
  form.fields.screeningSensitivity =
    holder.details?.renterRequirements?.screeningSensitivity ||
    investorStore.investor?.preferredScreeningSensitivity ||
    ScreeningSensitivity.MODERATE;
}

function save() {
  return form.submit((fields) => holder.saveRenterRequirements({ screeningSensitivity: fields.screeningSensitivity }));
}

watch(() => holder.details?.renterRequirements, populateForm, { immediate: true });

defineExpose({ save, form });
</script>
